module.exports = __webpack_public_path__ + "img/roata.8efa18a4.svg";